import React from 'react';
import { Link } from 'gatsby';
import { Container } from 'react-bootstrap';
import SEO from '../components/seo';
import PrimaryLogoSVG from '../components/svgs/primary-logo';
import Layout from '../layouts/default-layout';
var IndexPage = function IndexPage() {
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Home"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "border-bottom"
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "py-8 text-center"
    }, /*#__PURE__*/ React.createElement(PrimaryLogoSVG, {
        width: "40%",
        className: "svg-fill-beige mx-auto d-block mb-6"
    }), /*#__PURE__*/ React.createElement(Link, {
        to: "/brand-heart",
        className: "btn btn-outline-dark"
    }, "Explore the Brand Guidelines"))));
};
export default IndexPage;
